/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoRemoveSharedContactInput = {
    clientMutationId?: string | null;
    sharedSlug: string;
    slug: string;
};
export type RemoveSharedContactMutationVariables = {
    input: infoRemoveSharedContactInput;
};
export type RemoveSharedContactMutationResponse = {
    readonly infoRemoveSharedContact: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RemoveSharedContactMutation = {
    readonly response: RemoveSharedContactMutationResponse;
    readonly variables: RemoveSharedContactMutationVariables;
};



/*
mutation RemoveSharedContactMutation(
  $input: infoRemoveSharedContactInput!
) {
  infoRemoveSharedContact(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoRemoveSharedContactPayload",
    "kind": "LinkedField",
    "name": "infoRemoveSharedContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveSharedContactMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveSharedContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dfa89f5893afb856fbc1a7df8d97b1f6",
    "id": null,
    "metadata": {},
    "name": "RemoveSharedContactMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveSharedContactMutation(\n  $input: infoRemoveSharedContactInput!\n) {\n  infoRemoveSharedContact(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '203e77817cc313172e66c9425934cc85';
export default node;
